import { ADD_FILTER_TYPE, SET_FILTER, SET_FILTER_OPTIONS } from './appFiltersActionTypes';
export function addFilterType(type) {
  return {
    type: ADD_FILTER_TYPE,
    payload: {
      type: type
    }
  };
}
export function setFilterValues(type, value) {
  return {
    type: SET_FILTER,
    payload: {
      type: type,
      value: value
    }
  };
}
export function setFilterOptions(type, options) {
  return {
    type: SET_FILTER_OPTIONS,
    payload: {
      type: type,
      options: options
    }
  };
}